<script setup>
import { computed } from 'vue';

const props = defineProps({
  score: {
    type: Number,
    required: true,
    validator: value => value >= 0 && value <= 100,
  },
  factors: {
    type: Object,
    default: () => ({}),
  },
  showLabel: {
    type: Boolean,
    default: false,
  },
});

const category = computed(() => {
  if (props.score >= 70) return 'hot';
  if (props.score >= 40) return 'warm';
  return 'cold';
});

const colorClasses = computed(() => {
  const colors = {
    hot: 'bg-n-ruby-3 text-n-ruby-11 border-n-ruby-6',
    warm: 'bg-n-amber-3 text-n-amber-11 border-n-amber-6',
    cold: 'bg-n-slate-3 text-n-slate-11 border-n-slate-6',
  };
  return colors[category.value];
});

const categoryLabel = computed(() => {
  const labels = {
    hot: 'HOT_LEAD',
    warm: 'WARM_LEAD',
    cold: 'COLD_LEAD',
  };
  return labels[category.value];
});

const factorsTooltip = computed(() => {
  if (!props.factors || Object.keys(props.factors).length === 0) return '';

  return Object.entries(props.factors)
    .map(([key, value]) => `${key}: ${value}`)
    .join('\n');
});
</script>

<template>
  <div class="inline-flex items-center gap-2">
    <span
      :class="colorClasses"
      :title="factorsTooltip"
      class="px-2 py-1 rounded-full text-xs font-semibold border"
    >
      {{ score }}
    </span>
    <span v-if="showLabel" class="text-sm text-n-slate-11">
      {{ $t(`PIPELINE.LEAD_SCORE.${categoryLabel}`) }}
    </span>
  </div>
</template>
